export interface Category {
  slug: string;
  name: string;
  description: string;
  imageSeq: string;
  imagePrompt: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'beginner-guide',
    name: '新手攻略',
    description: '从零开始的洞窟冒险指南，涵盖基础操作、生存技巧、资源收集与初期任务指引，帮助新玩家快速上手。',
    imageSeq: 'cat-beginner',
    imagePrompt: 'Dark fantasy dungeon entrance with glowing torchlight on stone walls, ancient wooden signpost with mysterious runes, warm amber lighting creating long shadows, cinematic game concept art style with painterly textures, atmospheric depth, rich dark brown and gold tones',
    icon: 'ri-guide-line',
    articleCount: 5,
  },
  {
    slug: 'characters',
    name: '角色介绍',
    description: '全面解析哥布林洞窟中所有可玩角色与NPC，包括属性成长、技能树、背景故事与隐藏能力。',
    imageSeq: 'cat-characters',
    imagePrompt: 'Fantasy character lineup of adventurers in dark underground cave setting, warrior mage and rogue silhouettes against torch-lit stone background, dramatic rim lighting, dark fantasy illustration style with warm amber highlights, moody atmospheric composition',
    icon: 'ri-user-star-line',
    articleCount: 4,
  },
  {
    slug: 'story',
    name: '剧情解析',
    description: '深入解读哥布林洞窟的世界观设定、主线剧情、支线任务与隐藏结局，揭开洞穴深处的古老秘密。',
    imageSeq: 'cat-story',
    imagePrompt: 'Ancient underground library with crumbling stone shelves and glowing magical scrolls, mysterious green luminescent crystals embedded in cave walls, dark fantasy atmosphere with emerald and amber light interplay, painterly concept art with rich textural detail',
    icon: 'ri-book-open-line',
    articleCount: 3,
  },
  {
    slug: 'map-exploration',
    name: '地图探索',
    description: '完整的洞窟地图全貌，包含各层区域详解、隐藏通道、宝箱位置与传送点标记，助你绝不迷路。',
    imageSeq: 'cat-map',
    imagePrompt: 'Detailed fantasy dungeon map spread across weathered parchment on stone table, with compass rose and mysterious markings, candlelight illumination casting warm glow, cartography aesthetic with ink and aged paper textures, dark ambient atmosphere',
    icon: 'ri-map-2-line',
    articleCount: 4,
  },
  {
    slug: 'equipment',
    name: '装备道具',
    description: '全装备图鉴与获取方式，涵盖武器锻造、防具强化、饰品搭配与稀有道具的隐藏获取方法。',
    imageSeq: 'cat-equipment',
    imagePrompt: 'Display of fantasy weapons and armor arranged on dark stone pedestal in underground forge, glowing enchanted sword and shield reflecting firelight, warm forge fire illuminating the scene, dark fantasy still life with rich metallic textures and amber highlights',
    icon: 'ri-sword-line',
    articleCount: 3,
  },
  {
    slug: 'boss-guide',
    name: 'BOSS攻略',
    description: '洞窟各层BOSS的详细打法指南，包括技能机制解析、弱点暴露时机、推荐阵容配置与掉落奖励一览。',
    imageSeq: 'cat-boss',
    imagePrompt: 'Massive goblin king boss towering in dark cave throne room, surrounded by treasure hoard and glowing crystals, dramatic confrontation scene with epic scale, dark fantasy illustration with intense amber and emerald lighting, cinematic composition',
    icon: 'ri-skull-line',
    articleCount: 3,
  },
];